import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Mee › Hồ sơ giấy tờ (Docs.tsx). Mã nghiệp vụ và dữ liệu mẫu không dịch.
addMessages('vi', {
  'dc.contract': 'Hợp đồng',
  'dc.expiring': 'Giấy tờ có hạn',
  'dc.cancel': 'Huỷ',
  'dc.kind': 'Loại giấy tờ',
  'dc.issued': 'Ngày cấp',
  'dc.expires': 'Hết hạn',
  'dc.drop': 'Kéo bản scan PDF / ảnh vào đây',
  'dc.reqUpdate': 'Yêu cầu cập nhật',
  'dc.sendHr': 'Gửi HR xác nhận',
  'dc.addPaper': 'Thêm giấy tờ',
});
addMessages('en', {
  'dc.contract': 'Contract',
  'dc.expiring': 'Expiring documents',
  'dc.cancel': 'Cancel',
  'dc.kind': 'Document type',
  'dc.issued': 'Issue date',
  'dc.expires': 'Expires',
  'dc.drop': 'Drag a scanned PDF / image here',
  'dc.reqUpdate': 'Request update',
  'dc.sendHr': 'Send to HR to confirm',
  'dc.addPaper': 'Add document',
});
